<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">Test IPV</h3>
    </div>

</div>
<app-camera *ngIf="testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div *ngIf="texts" #instructions class="m-b-30"></div>

                <div class="col-12">
                    <button class="btn waves-effect btn-rounded btn-info mx-2 mx-2" (click)="reload()">Cancelar</button>
                    <button *ngIf="selectedQuestion" type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" (click)="startTest()" data-toggle="modal" data-target="#myModal" > Realizar test </button>

                </div>

                            <!-- sample modal content -->
                            <div id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                                <div class="modal-dialog modal-lg">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h4 class="modal-title" id="myModalLabel">IPV</h4>
                    
                                        </div>
                                        <div class="modal-body">
                                            <h4>Seleccione una opción</h4>

                                            <p>{{selectedQuestion.title}}</p>
                                            <div class="col">
                                                <a style="font-size: 15px;white-space:normal;" class="btn btn-block btn-lg btn-info text-white" (click)="select('A')" >{{selectedQuestion.opcA.text}}</a>
                                                <br>
                                            </div>
                                            <div class="col">
                                                <a style="font-size: 15px;white-space:normal;" class="btn btn-block btn-lg btn-info text-white" (click)="select('B')" >{{selectedQuestion.opcB.text}}</a>
                                                <br>
                                            </div>
                                            <div class="col">
                                                <a *ngIf="selectedQuestion.opcC.text" style="font-size: 15px;white-space:normal;" class="btn btn-block btn-lg btn-info text-white" (click)="select('C')" >{{selectedQuestion.opcC.text}}</a>
                                                <br>
                                            </div>


                                        </div>

                                    </div>
                                    <!-- /.modal-content -->
                                </div>
                                <!-- /.modal-dialog -->
                            </div>
                            <!-- /.modal -->
                      
               
            </div>
        </div>
    </div>
</div>